enum MarketBellSoundPreference {
  NEVER = 'NEVER',
  ONLY_MARKET_OPEN = 'ONLY_MARKET_OPEN',
  ONLY_MARKET_CLOSE = 'ONLY_MARKET_CLOSE',
  ALWAYS = 'ALWAYS'
}

export default MarketBellSoundPreference
